export default "__VITE_ASSET__Rp0f8Oyz__"